/*
 * Project: LegalPlace assistant
 * File: src/components/misc/radio_group.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
import LpSingleRadio from './radio';
import { generateId1 } from '../utils/misc';
import { lpGetOptionById } from '../../logic/re_index';
import lpApp from '../../app/lp_app';


class _RadioGroup extends Component {
  shouldComponentUpdate() {
    if ((lpApp.action_tracker.last_action === 'EDIT_VARIABLE_VALUE_')
      || (lpApp.action_tracker.last_action === 'IC_SET_VARIABLE')
      || (lpApp.action_tracker.last_action === 'IC_SET_OPTION')
    ) {
      return false;
    }
    return true;
  }

  render() {
    // console.log(filterSelected(this.props.id, this.props.value))
    return (
      <div key={generateId1(4)}>
        { this.props.id.map((idx, i) => {
          if (!lpApp.ops.two_steps.checkOption(idx)) {
            return (
              <LpSingleRadio
                id={idx}
                parent={this.props.parent}
                group={this.props.parent}
                label={lpApp.references.getOption(idx).meta.label}
                ovc="o"
                isDuplicate={this.props.isDuplicate}
                copy={this.props.copy}
                is_multiple={this.props.is_multiple}
                is_checked={this.props.value[i]}
                key={idx}
              />
            );
          }
          return (<div key={idx} />);
        })}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let cId = ownProps.id;
  if (ownProps.isDuplicate) cId = cId.map(idx => `${idx}_${ownProps.copy}`);
  // console.log(cId)
  return {
    value: cId.map(idx => (lpGetOptionById(idx) ? lpGetOptionById(idx).value : false)),
  };
};

const mapDispatchToProps = () => ({});

const RadioGroup = connect(mapStateToProps, mapDispatchToProps)(_RadioGroup);

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/misc/radio_group.js